import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

export default function WordWheelPointsTable({ rows = [], compact = false, loading = false }) {
    return (
        <Box
            sx={{
                borderRadius: 2,
                border: "1px solid rgba(15, 61, 54, 0.14)",
                bgcolor: "#fff",
                overflow: "hidden",
            }}
        >
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                    <CircularProgress size={22} sx={{ color: "#059669" }} />
                </Box>
            ) : (
                <Table size="small" aria-label="Word wheel coins by length">
                    <TableHead>
                        <TableRow sx={{ bgcolor: "rgba(5, 150, 105, 0.08)" }}>
                            <TableCell sx={{ fontWeight: 800, color: "#0f3d36", py: compact ? 0.75 : 1 }}>
                                Letters
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 800, color: "#0f3d36", py: compact ? 0.75 : 1 }}>
                                Coins
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={2} sx={{ py: 1.25, color: "rgba(15, 61, 54, 0.65)" }}>
                                    Coins catalog unavailable.
                                </TableCell>
                            </TableRow>
                        ) : (
                            rows.map((row) => (
                                <TableRow key={row.length}>
                                    <TableCell sx={{ py: compact ? 0.65 : 0.85, color: "#0f3d36" }}>
                                        {row.length} letters
                                    </TableCell>
                                    <TableCell align="right" sx={{ py: compact ? 0.65 : 0.85, fontWeight: 700, color: "#059669" }}>
                                        {row.coins ?? row.points}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            )}
            {!compact && !loading && rows.length > 0 && (
                <Typography variant="caption" sx={{ display: "block", px: 1.5, py: 1, color: "rgba(15, 61, 54, 0.65)" }}>
                    Puzzle score is the sum of coins for every word you find.
                </Typography>
            )}
        </Box>
    );
}
